'use client'
import React, { useState } from 'react'
import { convertDt24h, getImgURL, getSlugUrl } from '@/shared/utils'
import CustomLink from '@/shared/components/customLink'
import ThemeTable from '@/shared/components/themeTable'
import ToggleSwitch from '@/shared/components/switch'
import MyImage from '@/shared/components/myImage'
import downArrow from '@/assets/images/advertisement/icons/down-blue-arrow.svg'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'

function StandingTable({ roundData, standingsData }: any) {
  const [isForm, setIsForm] = useState({ isShow: false, labels: ['No', 'Team', 'M', 'W', 'L', 'T', 'N/R', 'PTS', 'Net RR', ''] })
  const [expandedIndex, setExpandedIndex] = useState<string>('')

  const table = { nPlayed: 'M', nWin: 'W', nLoss: 'L', nDraw: 'T', nNR: 'N/R', nPoints: 'PTS', nNetrr: 'Net RR' }

  function handleChange() {
    if (isForm.isShow) {
      setIsForm({ isShow: false, labels: ['No', 'Team', 'M', 'W', 'L', 'T', 'N/R', 'PTS', 'Net RR', ''] })
    } else {
      setIsForm({ isShow: true, labels: ['No', 'Team', 'Form'] })
    }
  }

  function handleTeamForm(id: string) {
    if (expandedIndex === id) {
      setExpandedIndex('')
    } else {
      setExpandedIndex(id)
    }
  }
  return (
    <>
      {standingsData?.[0]?.sLastFiveMatchResult?.length > 0 && <div className='flex items-center justify-end mx-1'></div>}
      {roundData?.map((round: any, i: number) => {
        return (
          <React.Fragment key={round._id}>
            <div className='flex justify-between w-full items-center mb-4 md:mb-6'>
              <h5 className='mb-0 font-bold text-sm text-textOffWhite md:text-lg'>{round?.sName}</h5>
              {i === 0 && (
                <div className=''>
                  <span className=' text-sm md:text-base font-medium text-textDselected mr-4'>Team Form</span>
                  <ToggleSwitch onChange={() => handleChange()} value={isForm.isShow} />
                </div>
              )}
            </div>
            <ThemeTable labels={isForm.labels} thClass={(index) => (index === 1 ? '!text-left' : '!text-end')}>
              {standingsData
                ?.filter((s: any) => round._id === s?.oRound?._id)
                .map((standing: any, index: number) => {
                  return (
                    <>
                      <tr key={standing._id} className={`${standing.highlight && 'highlight'} text-xs md:text-base`}>
                        <td className='w-14'>
                          <span className='ms-2'>{index + 1}</span>
                        </td>
                        <td className='min-w-[160px] !text-left !text-textOffWhite'>
                          <span className='hidden sm:flex gap-2'>
                            {standing?.oTeam?.eTagStatus === 'a' &&
                            standing?.oTeam?.oSeo?.eStatus === 'a' &&
                            standing?.oTeam?.oSeo?.sSlug ? (
                              <CustomLink
                                className='text-textOffWhite text-sm md:text-base flex items-center gap-2 md:gap-3 '
                                href={getSlugUrl(`/${standing?.oTeam?.oSeo?.sSlug}`)}
                              >
                                <MyImage
                                  src={getImgURL(standing?.oTeam?.oImg?.sUrl)}
                                  alt='team'
                                  width={24}
                                  placeholderImage={TeamPlaceholder}
                                  height={24}
                                  className='rounded-full md:w-6 md:h-6 w-5 h-5'
                                />
                                {standing?.oTeam?.sTitle}
                              </CustomLink>
                            ) : (
                              standing?.oTeam?.sTitle
                            )}
                            {standing.bIsTeamQualified && ' (Q)'}
                          </span>
                          <span className='flex gap-1 sm:hidden'>
                            {standing?.oTeam?.eTagStatus === 'a' && standing?.oTeam?.oSeo?.eStatus === 'a' ? (
                              <CustomLink
                                className='text-textOffWhite text-sm md:text-base flex items-center gap-2 md:gap-3 '
                                href={getSlugUrl(`/${standing?.oTeam?.oSeo?.sSlug}`)}
                              >
                                <MyImage
                                  src={getImgURL(standing?.oTeam?.oImg?.sUrl)}
                                  alt='team'
                                  width={24}
                                  height={24}
                                  placeholderImage={TeamPlaceholder}
                                  className='rounded-full md:w-6 md:h-6 w-5 h-5'
                                />
                                {standing?.oTeam?.sAbbr}
                              </CustomLink>
                            ) : (
                              standing?.oTeam?.sAbbr
                            )}
                            {standing.bIsTeamQualified && ' (Q)'}
                          </span>
                        </td>
                        {isForm.isShow ? (
                          <td>
                            <div className='flex gap-2 justify-end items-center'>
                              {standing?.sLastFiveMatchResult?.map((s: string, i: number) => {
                                return (
                                  <>
                                    
                                      <span
                                        key={i}
                                        className={`rounded items-center ${s === '' && 'bg-headersActive'} ${
                                          s === 'W'
                                            ? 'bg-[#00A532] dark:text-textOffWhite text-white'
                                            : s === 'd'
                                            ? 'bg-theme'
                                            : s === 'nr'
                                            ? 'bg-[#32393C]'
                                            : 'bg-[#E72D45] dark:text-textOffWhite text-white'
                                        }  h-5 w-5 md:w-6 md:h-6 flex justify-center font-bold text-xs`}
                                      >
                                        {s || <span className='block size-5 pb-1 md:size-6 text-t-origin '>-</span>}
                                      </span>
                                  
                                    {i === standing?.sLastFiveMatchResult?.length - 1 && (
                                      <span onClick={() => handleTeamForm(standing?.oTeam?._id)}>
                                        <MyImage
                                          src={downArrow}
                                          className={`size-4 !m-0 cursor-pointer transition-transform duration-300 ${
                                            expandedIndex === standing?.oTeam?._id ? 'rotate-180' : ''
                                          }`}
                                        />
                                      </span>
                                    )}
                                  </>
                                )
                              })}
                            </div>
                          </td>
                        ) : (
                          Object.keys(table)?.map((value) => {
                            return (
                              <td
                                key={value}
                                className={`w-14 !text-right  ${value === 'nNetrr' ? '!text-subSectionText' : '!text-textDselected'}`}
                              >
                                {standing[value]}
                              </td>
                            )
                          })
                        )}
                        {!isForm?.isShow && (
                          <td className='!m-0 !p-0 !w-[2px]' onClick={() => handleTeamForm(standing?.oTeam?._id)}>
                            <MyImage
                              src={downArrow}
                              className={`size-4 !m-0 cursor-pointer transition-transform duration-300   ${
                                expandedIndex === standing?.oTeam?._id ? 'rotate-180' : ''
                              }`}
                            />
                          </td>
                        )}
                      </tr>
                      {expandedIndex === standing?.oTeam?._id && (
                        <>
                          <tr className={`${expandedIndex === standing?.oTeam?._id ? 'transition-all' : 'transition-all animate-close'}`}>
                            <td colSpan={10}>
                              <ThemeTable className='mx-2' isBordered={false} labels={['Opponent', 'Description', 'Date', 'Result']}>
                                {standingsData
                                  ?.find((d: any) => d?.oTeam?._id === expandedIndex)
                                  ?.oRecentTeamMatches?.slice()
                                  ?.reverse()
                                  ?.map((f: any, i: number) => (
                                    <tr key={i}>
                                      {/* <td className='hidden md:block text-base'>{f?.oOpponent?.sTitle}</td> */}
                                      <td className='text-sm md:text-base ml-4 !text-textOffWhite'>
                                        <div className='flex items-center gap-2 md:gap-3'>
                                          <MyImage
                                            src={getImgURL(f?.oOpponent?.oImg?.sUrl)}
                                            alt='team'
                                            placeholderImage={TeamPlaceholder}
                                            width={24}
                                            height={24}
                                            className='rounded-full md:w-6 md:h-6 w-5 h-5'
                                          />{' '}
                                          {f?.oOpponent?.sAbbr}
                                        </div>
                                      </td>
                                      <td className='text-[12px] md:text-base !text-textDselected'>{f?.sDescription}</td>
                                      <td className='text-[12px] md:text-base !text-textDselected'>{convertDt24h(f?.dStartDate)}</td>
                                      <td>
                                        <span
                                          className={`${
                                            f?.iWinnerId === f?.oOpponent?.iTeamId
                                              ? 'text-red-500'
                                              : f?.iWinnerId === null && (f?.sResult === 'Match drawn' || f?.sResult === 'Match Drawn')
                                              ? 'text-blue-100'
                                              : f?.iWinnerId === null
                                              ? 'text-t-700'
                                              : 'text-subSectionText'
                                          } line-clamp-2 whitespace-pre-wrap md:w-full w-[85px] text-[12px] md:text-base`}
                                        >
                                          {f?.sResult || '-'}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                              </ThemeTable>
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )
                })}
            </ThemeTable>
          </React.Fragment>
        )
      })}
    </>
  )
}

export default StandingTable
